import { useMemo, useState } from 'react';

import _ from 'lodash';
import { Day, GetProgramResopnse, Week } from '../../lib/types/programEdit';
import { Box, Button, Collapse, Flex } from '@chakra-ui/react';
import { AddIcon, ChevronDownIcon, ChevronUpIcon, CopyIcon, DeleteIcon } from '@chakra-ui/icons';
import { CustomTitle } from './CustomTitle';
import { WeekDetail } from './WeekDetail';
import { DayPlan } from './DayPlan';

type WeekPlanProps = {
    weekIndex: number;
    week: Week; // replace `any` with your actual week type
    program: GetProgramResopnse;
    updateProgram: (updatedProgram: GetProgramResopnse) => void;
    onDayThumbnailFile?: (weekIndex: number,   
  dayIndex: number, file: File | null) =>  
  void; 
  };

export const WeekPlan = ({ weekIndex , week , program, updateProgram,onDayThumbnailFile}: WeekPlanProps) => {
    const [isCollapsed, setIsCollapsed] = useState(weekIndex === 0 ? false : true);
    const [addedNum, setAddedNum] = useState(0);

    const addDay = (weekIndex: number, newTypeId: number, newFormats: string[]) => {
        const updatedProgram = _.cloneDeep(program);
        const newDay: Day = {
          typeId: newTypeId,
          title: 'Custom Workout Title here',
          description: '',
          vimeoId: '',
          thumbnail: null,
          formats: newFormats,
          restDayId: null,    
          exercises: [],
          circuits: [],
          warmups: [],
        };
        updatedProgram.weeks[weekIndex].days.push(newDay);
        updateProgram(updatedProgram);
        setAddedNum(newTypeId);
    };

    const duplicateWeek = (weekIndex: number) => {
        const originWeek = program.weeks[weekIndex];
        const newWeek = _.cloneDeep(originWeek);
        delete newWeek._id;
        newWeek.days.map((day) => {
          delete day._id;
          day.exercises.map((exercise) => {
            delete exercise._id;
          });
          (day.circuits || []).map((circuit) => {
            delete circuit._id;
            circuit.circuitExercises.map((exercise) => {
              delete exercise._id;
            });
          });
          (day.warmups || []).map((warmup) => {
            delete warmup._id;
            warmup.circuitExercises.map((exercise) => {
              delete exercise._id;
            });
          });
        });
        const updatedProgram = _.cloneDeep(program);
        updatedProgram.weeks.splice(weekIndex + 1, 0, newWeek);
        updateProgram(updatedProgram);
    };
    const updateWeek = (weekIndex: number, updatedWeek: Week) => {
        const updatedProgram = _.cloneDeep(program);
        updatedProgram.weeks[weekIndex] = updatedWeek;
        updateProgram(updatedProgram);
    };
    const deleteWeek = (weekIndex: number) => {
        const updatedProgram = _.cloneDeep(program);
        updatedProgram.weeks.splice(weekIndex, 1);
        updateProgram(updatedProgram);
    };

    const reassignDayTypeIds = (deletedDayTypeId: number) => {
        const updatedProgram = _.cloneDeep(program);
        const days = updatedProgram.weeks[weekIndex].days;
        days.forEach((day, index) => {
          if (day.typeId > deletedDayTypeId) day.typeId--;
        });
        updateProgram(updatedProgram);
    };

    const updateWeekTitle = (title: string) => {
        const updatedWeek = { ...week, title };
        updateWeek(weekIndex, updatedWeek);
    };

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

  return (
    <Box
      my={4}
      p={4}
      borderWidth="1px"
      borderRadius="md"
      boxShadow="md"
      backgroundColor="primary.50"
      className="week"
    >
        <Flex justify="space-between" align="center">
            <Box flex="1" mr={5}>
                <CustomTitle
                    type={'Week'}
                    index={weekIndex + 1}
                    customTitle={week.title}
                    updateFunction={updateWeekTitle}
                />
            </Box>
            <Button
                backgroundColor="primary.300"
                leftIcon={<CopyIcon mr={'-2'}/>}
                _hover={{ bg: 'primary.500' }}
                mr={2}
                onClick={() => duplicateWeek(weekIndex)}
            />
            <Button
                backgroundColor="primary.300"
                leftIcon={<DeleteIcon mr={'-2'}/>}
                _hover={{ bg: 'primary.500' }}
                mr={5}
                onClick={() => deleteWeek(weekIndex)}
            />
            <Button
                backgroundColor="primary.300"
                leftIcon={isCollapsed ? <ChevronDownIcon mr={'-2'}/> : <ChevronUpIcon mr={'-2'}/>}
                onClick={toggleCollapse}
                _hover={{ bg: 'primary.500' }}
            />
        </Flex>

        <Collapse in={!isCollapsed} animateOpacity>
            <WeekDetail weekIndex={weekIndex} week={week} updateWeek={updateWeek} />
            {week.days.map((day, dayIndex) => (
                <DayPlan
                    key={day._id ?? `day-${day.typeId}`}
                    weekIndex={weekIndex}
                    dayIndex={dayIndex}
                    day={day}
                    addDay={addDay}
                    reassignDayTypeIds={reassignDayTypeIds}
                    program={program}
                    updateProgram={updateProgram}
                    isWeekCollapsed={isCollapsed}
                    addedNum = {addedNum}
                    totaldays={week.days.length}
                    onDayThumbnailFile={onDayThumbnailFile}
                />
            ))}
            {week.days.length < 7 &&
                <Button
                colorScheme='primary'
                leftIcon={<AddIcon />}
                onClick={() => addDay(weekIndex, week.days.length + 1, [])}
                >
                    Add Workout
                </Button>
            }
        </Collapse>
    </Box>
  );
};
